import { render, staticRenderFns } from "./ModalNotice.vue?vue&type=template&id=36ae3a8a&scoped=true"
import script from "./ModalNotice.vue?vue&type=script&lang=js"
export * from "./ModalNotice.vue?vue&type=script&lang=js"
import style0 from "./ModalNotice.vue?vue&type=style&index=0&id=36ae3a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae3a8a",
  null
  
)

export default component.exports